import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-textarea',
    templateUrl: './textarea.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextareaComponent implements OnInit {
  @Input() placeholder: string = "";
  @Input() label?: string;
  @Input() required: boolean = false;
  @Input() variant?: string;
  @Input() class?: string;
  @Input() model?: any;
  @Input() disabled: boolean = false;
  @Input() rows?: number = 4;

  @Output() onChanges = new EventEmitter<any>();

  name: string = 'txt';
  constructor() {}

  ngOnInit() {
    this.name += this.label ? this.label : this.placeholder  
  }

  onModelChange(e: any) {
    this.onChanges.emit(e);
  }
}
